import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "返回-return",
  "use": "返回-return-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"返回-return\"><g data-follow-fill=\"#027AFF\" fill=\"#027AFF\" fill-rule=\"evenodd\"><path d=\"M3.288 8.177V6.583h8.86a5.3 5.3 0 1 1 0 10.6l-5.702-.001v-1.594h5.695a3.706 3.706 0 0 0 0-7.41l-8.853-.001Z\" /><path d=\"M3.296 6.583 9.33 3.071l.801 1.322-5.903 3.47-.18.1h-.752z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol